<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li class="is-active">
          <a href="#" aria-current="page">Posts to flag</a>
        </li>
      </ul>
    </nav>

    <transition name="page">
      <section v-if="loaded">
        <div class="card">
          <div class="card-content">
            <b-field
              grouped
              v-if="posts.length"
              position="is-right">
              <b-select v-model="perPage">
                <option value="5">5 per page</option>
                <option value="10">10 per page</option>
                <option value="15">15 per page</option>
                <option value="20">20 per page</option>
              </b-select>
            </b-field>

            <b-table
              :data="posts"
              :per-page="perPage"
              :loading="isLoading"
              :paginated="!!posts.length"
              :show-detail-icon="true"
              detail-key="id"
              detailed
              hoverable>
              <template slot-scope="props">
                <b-table-column field="user.name" label="User" sortable width="150">
                  {{ props.row.user.name }}
                </b-table-column>

                <b-table-column field="description" label="Description" sortable>
                  {{ props.row.description }}
                </b-table-column>

                <b-table-column field="actions" width="40">
                  <b-dropdown position="is-bottom-left">
                    <button class="button is-info" slot="trigger">
                        <b-icon icon="menu-down"></b-icon>
                    </button>

                    <b-dropdown-item has-link>
                      <a @click.prevent.stop="showBanModal(props.row)">Ban</a>
                      <a @click.prevent.stop="unbanPost(props.row)">UnBan</a>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-table-column>
              </template>

              <template slot="detail" slot-scope="props">
                <article class="media">
                  <figure class="media-left" v-if="props.row.type !== 'video'">
                    <p class="image is-64x64">
                      <img :src="props.row.media_url">
                    </p>
                  </figure>
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong>{{ props.row.user.name }}</strong>
                        <small>@{{ props.row.user.nickname }}</small>
                        <small>- {{ props.row.created_at.date | moment('MMMM DD, YYYY') }}</small>
                        <br>
                        {{ props.row.description }}
                      </p>
                    </div>
                  </div>
                </article>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                        icon="emoticon-sad"
                        size="is-large">
                      </b-icon>
                    </p>
                    <p>Nothing here.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </section>
    </transition>

    <b-modal :active.sync="isBanModalActive" has-modal-card>
      <div class="card">
        <div class="card-content text-center">
          <span class="z-exclamation-outline is-size-2 text-red mb-2"></span>
          <p class="font-medium text-xl">Are you sure you want to flag the record?</p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item font-bold text-red hover:text-red-light" @click="banPost">Yes, I'm sure</a>
          <a class="card-footer-item font-bold text-blue hover:text-blue-light" @click="isBanModalActive = false">Cancel</a>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'postspending',
  data: () => ({
    isBanModalActive: false,
    loaded: false,
    perPage: 10,
    selectedPost: {},
  }),
  computed: {
    ...mapState({
      isLoading: state => state.postspending.isLoading,
      posts: state => state.postspending.all,
    })
  },
  async created() {
    await this.fetch();
    this.loaded = true;
  },
  methods: {
    ...mapActions('postspending', ['fetch', 'ban', 'unban']),

    showBanModal(post) {
      this.selectedPost = post;
      this.isBanModalActive = true;
    },

    async banPost() {
      this.isBanModalActive = false;
      await this.ban(this.selectedPost);
    },

    async unbanPost(post) {
      await this.unban(post);
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/PostsPending.vue